import {useTranslation} from 'react-i18next';
import SingleText from '../../../common/component/SingleText';
import useEventHandleMission from '../../hook/useEventHandleMission';
import {IPreRequestModuleV4} from '../../type';
import EventButtonV4 from '../EventButtonV4';
import EventRowItemV4 from '../EventRowItemV4';
import ModuleSectionV4 from '../ModuleSectionV4';

interface IProps {
  data: IPreRequestModuleV4;
}

export default function MissionPreRequestModuleV4({data}: IProps) {
  const {t} = useTranslation();
  const {section, isCompleted} = data;

  const handleMission = useEventHandleMission();
  const handleClickButton = () => {
    handleMission({
      actionName: 'attendance_booking',
      disabled: isCompleted,
    });
  };

  return (
    <ModuleSectionV4 section={section} data-module-type="pre-request">
      <EventRowItemV4
        isRound
        showBoxShadow
        className={cn('gap-x-18', {
          'bg-white/5': isCompleted,
          'bg-white/20': !isCompleted,
        })}
        leftElement={
          <SingleText
            className={cn(
              's15-bold-white leading-19 tracking-[-0.4px]',
              isCompleted && 'opacity-30'
            )}
          >
            {t('crm_attendance_advance_register')}
          </SingleText>
        }
        rightElementClassName="flex-shrink-0"
        rightElement={
          <EventButtonV4
            isWhiteBg
            disabled={isCompleted}
            text={t('crm_attendance_advance_register_button')}
            onClick={handleClickButton}
          />
        }
      />
    </ModuleSectionV4>
  );
}
